module.exports = __webpack_public_path__ + "assets/img/bg1.2780d390.png";